export default __webpack_public_path__ + "static/media/constellation_3.05320011.png";